module.exports = __webpack_public_path__ + "img/pyramid-three.899047c1.svg";